module.exports = __webpack_public_path__ + "img/1511796352.68e8573f.jpg";